<template>
  <ItemPage
    title="Feedback Reports do portal"
    size="md"
  >
    <v-simple-table fixed-header>
      <template v-if="loading">
        <Load :loadingmsg="loadingMsg" />
      </template>
      <div
        v-else
      >
        <v-data-table
          :headers="headers"
          :items="contents"
          :items-per-page="15"
          hide-default-footer
          item-key="id"
        >
          <template #item.title="{ item }">
            <router-link :to="{ name: 'feedbackReports.id', params: { id: item.id } }">
              {{ item.title }}
            </router-link>
          </template>
          <template #item.status="{ item }">
            {{ item.status }}
          </template>
          <template #item.created_at="{ item }">
            {{ dayjs(item.created_at).fromNow() }}
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="totalPages"
          :total-visible="5"
          class="mt-4"
        />
      </div>
    </v-simple-table>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'
import dayjs from '@/dayjs'

export default {
  components: {
    Load,
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      educationSystemView: false,
      loading: false,
      loadingMsg: '',
      contents: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'title'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Abertura',
          align: 'start',
          value: 'created_at'
        }
      ],

      // Pagination
      page: 1,
      totalPages: 1
    }
  },

  async mounted () {
    await this.ListFeedbackReports()
  },
  methods: {
    async ListFeedbackReports () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.ListFeedbackReports(this.page)
        this.contents = content.data
        this.totalPages = content.meta.last_page
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    dayjs
  }
}
</script>
